import { render, staticRenderFns } from "./TitleMainDisplay.vue?vue&type=template&id=461dd647&scoped=true&"
import script from "./TitleMainDisplay.vue?vue&type=script&lang=ts&"
export * from "./TitleMainDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./TitleMainDisplay.vue?vue&type=style&index=0&id=461dd647&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461dd647",
  null
  
)

export default component.exports